module.exports = __webpack_public_path__ + "img/finger.781f7870.gif";